export const PREMIER_PLAN_LABEL = 'Premier Plan'

const BANK_STATEMENT_REDACTION_TOOLTIP =
  'Automatically redacts sensitive details from applicant bank statements.'
const PREMIER_UPGRADE_TOOLTIP_SUFFIX = 'Available on Premier Plans.'
const TEAM_ADMIN_UPDATE_TOOLTIP_SUFFIX = 'Team admin can update.'

export function getBankStatementRedactionTooltip(
  isSettingEnabled: boolean,
  isAdmin: boolean,
): string {
  if (!isSettingEnabled) {
    return `${BANK_STATEMENT_REDACTION_TOOLTIP} ${PREMIER_UPGRADE_TOOLTIP_SUFFIX}`
  }
  if (!isAdmin) {
    return `${BANK_STATEMENT_REDACTION_TOOLTIP} ${TEAM_ADMIN_UPDATE_TOOLTIP_SUFFIX}`
  }
  return BANK_STATEMENT_REDACTION_TOOLTIP
}
